import Logo from '../_media/branding/clashbot_logo.svg'
import AppBarTemplate from '../_shoru_shared_library/template/AppBarTemplate';

function ClashBotAppBar(props) {

  return (
    <AppBarTemplate
      title='ClashBot'
      subtitle='shoru'
      logo={Logo}
      userData={props.userData}
      projectData={props.projectData}
      showAppsIcon={false}
    />
  )

}

export default ClashBotAppBar;